<template>
    <div class="page">
        <div v-if="loading" class="loading">
            <a-spin size="large" />
        </div>
        <div v-else>
            <div class="title">按{{ key }}+P打印班级二维码</div>
            <div class="content">
                <div class="list" :class="{ 'fix': true }">
                    <div class="item" v-for="(item, index) in classList" :key="index"
                        :class="{ 'break': (classList.length - index > 2) && ((index + 1) % 6 == 0 || (index + 1) % 6 == 5) }">
                        <div class="text">
                            <div>课后班级：</div>
                            <div style="flex: 1;">{{ item.className }}({{ item.classId }})</div>
                        </div>
                        <div class="text">
                            老师姓名：{{ item.teacherName || '未设置老师' }} <span style="margin-left: 20px;">学生人数：</span>{{
                                item.studentCount }}
                        </div>
                        <div class="qr-code">
                            <img :src="item.qrcodeUrl" alt="" v-if="item.qrcodeUrl">
                            <div v-else class="no-qrcode">
                                <a-empty description="未上传二维码" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import classSet from '../../api/classSet'
export default {
    data() {
        return {
            key: '',
            classList: [],
            loading: true,
        }
    },
    created() {
        this.key = navigator.userAgent.includes('Windows') ? 'Ctrl' : 'Command'
        this.getList()
    },
    methods: {
        getList() {
            classSet.getQRcodeList({ termId: this.$route.params.id }).then(res => {
                if (!res.data) {
                    this.$message.warn('该学期暂未创建家校沟通群')
                    setTimeout(function () {
                        window.close()
                    }, 3000)
                } else {
                    this.classList = res.data
                    this.loading = false
                }
            })
        },
    },
}
</script>

<style lang="less" scoped>
.page {
    width: 100%;

    .title {
        text-align: center;
        padding: 20px 0;
        font-size: 20px;
        font-weight: bold;
    }
}

.content {
    display: flex;
    justify-content: center;
}

.loading {
    text-align: center;
    padding-top: 42vh;
}

.list {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    padding: 20px 2cm;
    max-width: 21cm;

    .item {
        width: 8.3cm;
        height: 8.1cm;
        border: 1px solid #666;
        padding: 10px;
        margin: 0.1cm;

        .qr-code {
            margin-top: 2px;
            text-align: center;

            img {
                width: 6cm;
                height: 6cm;
                object-fit: cover;
            }

            .no-qrcode {
                margin: 0 auto;
                width: 6cm;
                height: 6cm;
                background-color: #fafafa;
                padding-top: 1cm;
            }
        }

        .text {
            display: flex;
        }
    }

}

@media print {
    .title {
        display: none;
    }

    .list {
        padding: 2.4cm 2cm;
    }

    .break {
        margin-bottom: 4.8cm !important;
    }
}

@page {
    size: A4 portrait;
    margin: 0;
}
</style>